import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M50.001 96.278c-12.78 0-24.35-5.18-32.724-13.554C8.902 74.349 3.722 62.78 3.722 50.002c0-12.78 5.18-24.351 13.554-32.725S37.221 3.722 50.001 3.722c12.779 0 24.348 5.181 32.722 13.555 8.374 8.375 13.554 19.945 13.554 32.725 0 12.778-5.18 24.348-13.554 32.721-8.375 8.375-19.944 13.555-32.722 13.555M19.889 80.111C27.594 87.815 38.241 92.582 50 92.582s22.405-4.767 30.109-12.471C87.814 72.406 92.58 61.76 92.58 50.002c0-11.76-4.765-22.407-12.47-30.112-7.705-7.706-18.35-12.472-30.109-12.472S27.594 12.184 19.889 19.89C12.183 27.595 7.418 38.241 7.418 50.002c0 11.759 4.765 22.404 12.471 30.109m47.342-31.958H51.847V32.768a1.849 1.849 0 0 0-3.696 0v15.385H32.768a1.848 1.848 0 0 0 0 3.696h15.384v15.383a1.848 1.848 0 0 0 3.696 0V51.848h15.383a1.848 1.848 0 1 0 0-3.695",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }